import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import 'antd/dist/antd.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Provider } from 'react-redux';
import reducer from './reducers';

import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

import { LiffProvider } from 'react-liff';

const liffId = process.env.REACT_APP_LINE_LIFF_ID;
const stubEnabled = process.env.NODE_ENV !== 'production';

const store = createStore(
  reducer,
  composeWithDevTools()
  // applyMiddleware(...middleware)
  // other store enhancers if any
);

// console.log("liffId =>", liffId);

ReactDOM.render(
  // <React.StrictMode>
  <LiffProvider
    liffId={`${liffId}`}
    stubEnabled={stubEnabled && true}
  >
    <Provider store={store}>
      <App />
    </Provider>
  </LiffProvider>,
  // </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
